import { useEffect, useState } from "react";
import { Box, Stack, TextField } from "@mui/material";

export const ModifiedTextField = (props) => {
  let {
    heading,
    minimumValue,
    requirement,
    value,
    setValue,
    read,
    onChange,
    placeholder,
    name,
    type,
    maxLength,
    isDisabled = false,
    isError = false,
    errorMessage = "",
  } = props;

  return (
    <Stack spacing={1}>
      <Box className="font-16 font-weight-600 line-height-24 black-heading  font-family ">
        {heading}{" "}
      </Box>
      <TextField
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event)}
        error={isError}
        helperText={errorMessage}
        sx={{
          padding: "0px",
          borderRadius: "0px",
          height: "40px !important",
          "& .MuiOutlinedInput-input": {
            padding: "8.5px 14px !important",
          },
        }}
        type={type}
        disabled={isDisabled}
        InputProps={{
          style: {
            fontFamily: "Source Sans Pro",
            color: "#313131",
            fontSize: "16px",
            fontWeight: "400",
            borderRadius: "0px",
          },
          readOnly: read,
        }}
        slotProps={{
          htmlInput: {
            maxLength: { maxLength },
          },
        }}
      />
    </Stack>
  );
};
